import { buildImageHost } from "./buildImageURL";
import { Brand } from "types/common";
import { AmpVideoLink } from "types/amplience";

const buildVideoFrame = (video: AmpVideoLink, frame: number, brand: Brand) => {
  const imageHost = buildImageHost(video.defaultHost, brand);

  const frameFormat = frame.toString().padStart(4, "0");

  return new URL(`https://${imageHost}/v/${video.endpoint}/${video.name}/thumbs/frame_${frameFormat}`).toString();
};

export default buildVideoFrame;
